import { AttributesFilterInputInterface } from '../interfaces/AttributesFilterInputInterface';
import { AttributeNameValuesPairInterface } from '../interfaces/AttributeNameValuesPairInterface';
import { parseValue } from './parseValue';

function processValues(inputValues: AttributeNameValuesPairInterface[], targetName: string): string[] {
    if (inputValues.length === 0) {
        return [];
    }
    const out: string[] = [];
    for (const { name, values } of inputValues) {
        if (name === targetName && values && values.length > 0) {
            for (const item of values) {
                const v = parseValue(item);
                if (v) {
                    out.push(v);
                }
            }
        }
    }
    return out;
}

function iterate(filter: AttributesFilterInputInterface, targetName: string): string[] {
    let out: string[] = [];
    const valuesResult = processValues(filter.values, targetName);
    if (valuesResult && valuesResult.length > 0) {
        valuesResult.forEach((v) => out.push(v));
    }
    const or = filter.or || [];
    if (or.length > 0) {
        for (const orValue of or) {
            const orResult = iterate(orValue, targetName);
            out = [...out, ...orResult];
        }
    }
    const and = filter.and || [];
    if (and.length > 0) {
        for (const andValue of and) {
            const andResult = iterate(andValue, targetName);
            out = [...out, ...andResult];
        }
    }
    return out;
}

export function getValueFromFilter(filter: AttributesFilterInputInterface, name: string): string[] {
    return iterate(filter, name);
}
